<template>

    <div class="modal" ref="modal">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('public.register.header') }}</h5>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import {Modal} from "bootstrap/js/src";
export default {

    props: {
        openOnLoad: {
            required: false,
            default: false,
        },
    },

    data: function () {
        return {
            modal : null,
        };
    },

    mounted: function () {
        this.modal = new Modal(this.$refs.modal);
        window.bus.$on("openSignupModal", this.open);
        if(!!this.openOnLoad) {
            this.open();
        }
    },
    destroyed: function () {
        window.bus.$off("openSignupModal", this.open);
    },

    methods: {
        open: function () {
            if(this.modal) {
                this.modal.show();
            }
        },
        close: function () {
            if(this.modal) {
                this.modal.hide();
            }
        },

    }

}

</script>

<style scoped>
    label {
        font-weight: lighter;
        font-size: .9rem;
        margin-bottom: 0;
        user-select: none;
    }
    .alert {
        font-weight: lighter;
    }
</style>
